import React, {useState} from "react";
import {connect} from "react-redux";
import 'moment/locale/ru';
import TextareaAutosize from "react-autosize-textarea";
import Loader from "react-loaders";
import {ReactMic} from '@cleandersonlobo/react-mic';
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {
    Button,
    Form,
    Input,
    InputGroup,
    InputGroupAddon,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from "reactstrap";
import isEmpty from "lodash/isEmpty";

import {postRequestDjango, patchRequestDjango} from "../../../requests";
import {sendMessage} from "../../../thunks/Chats";
import GoogleMapWrapper from "../../../Components/GoogleMapWrapper";
import cx from "classnames";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFile, faUser, faLocationArrow} from "@fortawesome/free-solid-svg-icons";
import ListContacts from "./ListContacts";
import ButtonWithSpinner from "../../../Components/ButtonWithSpinner";

const SendForm = (
    {
        activeChat,
        wsConnected,

        sendMessage,
    }
) => {
    const {t, i18n} = useTranslation();

    const [fileModalOpen, setFileModalOpen] = useState(false);
    const [fileIsUploading, setFileIsUploading] = useState(false);
    const [fileUploaded, setFileUploaded] = useState(undefined);

    const [record, setRecord] = useState(false);

    const [fileMymeType, setFileMymeType] = useState('');

    const [fileUploadFailed, setFileUploadFailed] = useState(false);
    const [isImage, setIsImage] = useState(false);

    const [uploadAsVideo, setUploadAsVideo] = useState(undefined);
    const [isVideo, setIsVideo] = useState(false);


    const [isAudio, setIsAudio] = useState(false);

    const [messageTextareaValue, setMessageTextareaValue] = useState('');
    const [fileInput, setFileInput] = useState(undefined);

    const [contactsModalOpen, setContactsModalOpen] = useState(false);
    const [contactsList, setContactsList] = useState([]);
    const [contactsLoading, setContactsLoading] = useState(false);

    const [locationModalOpen, setLocationModalOpen] = useState(false);
    const [locationLatLng, setLocationLatLng] = useState(null);

    const onMessageTextareaKeyPress = (event) => {
        if (!isEmpty(activeChat) && event.charCode === 13) {
            event.preventDefault();
            event.stopPropagation();

            sendTextMessage();
        }
    };

    const clearFileInfo = () => {
        setIsAudio(false);
        setIsVideo(false);
        setUploadAsVideo(false);
        setIsImage(false);
        setFileIsUploading(false);
        setFileUploadFailed(false);
    }

    const onMessageTextareaSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();

        sendTextMessage();
    };

    const sendTextMessage = () => {
        const trimValue = String(messageTextareaValue).trim();
        if (isEmpty(activeChat) || !trimValue) {
            return;
        }

        setMessageTextareaValue('');

        sendMessage(
            activeChat.id,
            'text',
            {
                text: trimValue,
            },
            // () => {
            //     if (!wsConnected) {
            //         setTimeout(loadLastMessagesAPI, 1000);
            //     }
            // }
        )
    };
    const failedToUpload = () => {
        toast.error(t('messages.new_message.toast.error.failed_to_upload', 'System failed to upload file'));
        toggleFileModal(false);
    }

    const onRecordFinished = (recordedBlob) => {


        setFileUploaded(undefined);
        setFileIsUploading(true);
        let filename = new Date().getTime() + '.mp3';
        let formData = new FormData();
        formData.append("file", recordedBlob.blob, filename);
        formData.append("encodeTo", "oga");
        toggleFileModal();
        postRequestDjango(`/cdn/upload/${filename}/`, formData, {timeout: 30000}).then(
            ({data}) => {
                if (!data.error) {
                    setIsAudio(true);
                    setFileUploaded(data.result.cdn_filepath);
                    setFileIsUploading(false);
                    setFileUploadFailed(false);
                } else {
                    failedToUpload();
                }
            },
            () => {
                failedToUpload();
            },
        );
    }
    const changeFileType = (changeIsVideoTo) => {

        setFileIsUploading(true);
        setFileUploadFailed(false)
        const contentType = changeIsVideoTo ? fileMymeType : 'file';
        const filename = fileUploaded.toString().split("/").slice(3).join("/");

        let formData = new FormData();
        formData.append('filename', filename);
        formData.append('type', contentType);

        patchRequestDjango(`/cdn/upload/some/`, formData, {timeout: 30000}).then(
            (request) => {
                setUploadAsVideo(changeIsVideoTo);
                setFileIsUploading(false);
                setFileUploadFailed(false);
            },
            () => {

                setFileIsUploading(false);
                setFileUploadFailed(true);
            },
        );

    }
    const sendFileMessage = () => {
        const trimValue = String(messageTextareaValue).trim();
        if (isEmpty(activeChat) || fileIsUploading || fileUploadFailed) {
            return;
        }

        setFileUploaded(undefined);
        setFileModalOpen(false);
        setMessageTextareaValue('');

        const data = {
            text: trimValue,
        };
        const type = isImage && 'image' || uploadAsVideo && 'video' || isAudio && 'voice' || 'file';
        const fileType = isImage && 'image' || uploadAsVideo && 'video' || 'file';
        data[`${fileType}_url`] = fileUploaded;

        sendMessage(
            activeChat.id,
            type,
            data,
            // () => {
            //     if (!wsConnected) {
            //         setTimeout(loadLastMessagesAPI, 1000);
            //     }
            // }
        )
        clearFileInfo();
    };

    const toggleFileModal = (explicitlySet = -1) => {

        if (fileModalOpen || explicitlySet === false) {
            if (fileInput) {
                fileInput.value = null;
            }
            //do stuff after hideout animation
            setTimeout(() => {
                clearFileInfo();
            }, 1000)
        }

        setFileModalOpen(explicitlySet !== -1 && typeof explicitlySet !== 'object' ? explicitlySet : !fileModalOpen);
    };

    const onFileModalChange = (event) => {
        setFileUploaded(undefined);
        setFileIsUploading(true);

        const file = event.target.files[0];
        // Check the file type.
        console.log('Upload ' + file.type);
        setFileMymeType(file.type)

        const isImage = file.type.match('image.*');
        setIsImage(isImage);

        if (isImage && ['image/png', 'image/jpeg', 'image/gif'].indexOf(file.type) === -1) {
            setFileUploaded(undefined);
            setFileIsUploading(false);
            setFileUploadFailed(true);
            toast.error(t('messages.new_message.toast.error.choose_image', 'Select PNG, JPEG or GIF image'));
            return;
        }

        const isVideo = file.type.match('video.*');
        setIsVideo(isVideo);
        setUploadAsVideo(isVideo);
        if (isVideo && ['video/mp4', 'image/3gpp'].indexOf(file.type) === -1) {
            setFileUploaded(undefined);
            setFileIsUploading(false);
            setFileUploadFailed(true);
            toast.error(t('messages.new_message.toast.error.choose_video', 'Choose video with MP4 or GP format'));
            return;
        }


        toggleFileModal();

        let formData = new FormData();
        formData.append('file', file);

        postRequestDjango(`/cdn/upload/${file.name}/`, formData, {timeout: 30000}).then(
            ({data}) => {
                if (!data.error) {
                    setFileUploaded(data.result.cdn_filepath);
                    setFileIsUploading(false);
                    setFileUploadFailed(false);
                } else {
                    failedToUpload();
                }
            },
            () => {
                failedToUpload();
            },
        );
    };

    const onImageTextareaKeyPress = (event) => {
        if (!isEmpty(activeChat) && event.charCode === 13) {
            event.preventDefault();
            event.stopPropagation();

            sendFileMessage();
        }
    };

    const onImageTextareaSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();

        sendFileMessage();
    };

    const sendLocationMessage = (event) => {
        event.preventDefault();

        const trimValue = String(messageTextareaValue).trim();
        if (isEmpty(activeChat) || isEmpty(locationLatLng)) {
            return;
        }

        setLocationModalOpen(false);
        setMessageTextareaValue('');

        const data = {
            lat: `${locationLatLng.lat}`,
            lng: `${locationLatLng.lng}`,
            name: trimValue
        };

        sendMessage(
            activeChat.id,
            "location",
            data
        )

        setLocationLatLng(null);
    };
    const sendContactMessage = (event) => {
        event.preventDefault();
        setContactsLoading(true);
        sendMessage(
            activeChat.id,
            'contact',
            {"contacts": contactsList},
            () => {
                setContactsLoading(false);
                setContactsModalOpen(false);
                setContactsList([]);
            }
        )
    }

    return <>
        <ReactMic
            record={record}
            className="sound-wave-hidden"
            onSave={onRecordFinished}
            strokeColor="#000000"
            backgroundColor="#FF4081"
            mimeType="audio/mp3"/>
        <input
            id="fileInput"
            type="file"
            ref={(ref) => setFileInput(ref)}
            className='d-none'
            onChange={onFileModalChange}
            // accept="image/png, image/jpeg, image/gif"
        />
        <Form
            className="app-inner-layout__bottom-pane d-block text-center border-top send-message-form"
            onSubmit={onMessageTextareaSubmit}
        >
            <InputGroup className='px-2 py-2'>
                <UncontrolledDropdown className="input-group-prepend" direction="up">
                    <DropdownToggle color="light">
                        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 24 24" width="24" height="24">
                            <path fill="#263238" fillOpacity=".5"
                                  d="M1.816 15.556v.002c0 1.502.584 2.912 1.646 3.972s2.472 1.647 3.974 1.647a5.58 5.58 0 0 0 3.972-1.645l9.547-9.548c.769-.768 1.147-1.767 1.058-2.817-.079-.968-.548-1.927-1.319-2.698-1.594-1.592-4.068-1.711-5.517-.262l-7.916 7.915c-.881.881-.792 2.25.214 3.261.959.958 2.423 1.053 3.263.215l5.511-5.512c.28-.28.267-.722.053-.936l-.244-.244c-.191-.191-.567-.349-.957.04l-5.506 5.506c-.18.18-.635.127-.976-.214-.098-.097-.576-.613-.213-.973l7.915-7.917c.818-.817 2.267-.699 3.23.262.5.501.802 1.1.849 1.685.051.573-.156 1.111-.589 1.543l-9.547 9.549a3.97 3.97 0 0 1-2.829 1.171 3.975 3.975 0 0 1-2.83-1.173 3.973 3.973 0 0 1-1.172-2.828c0-1.071.415-2.076 1.172-2.83l7.209-7.211c.157-.157.264-.579.028-.814L11.5 4.36a.572.572 0 0 0-.834.018l-7.205 7.207a5.577 5.577 0 0 0-1.645 3.971z"/>
                        </svg>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-hover-link dropdown-menu-auto">
                        <DropdownItem className="d-flex align-items-center justify-content-center px-3"
                                      onClick={() => fileInput.click()}
                                      disabled={isEmpty(activeChat)}
                        >
                            <FontAwesomeIcon icon={faFile} className="font-size-lg"/>
                        </DropdownItem>
                        <DropdownItem divider/>
                        <DropdownItem className="d-flex align-items-center justify-content-center px-3"
                                      onClick={() => setLocationModalOpen(true)}
                                      disabled={isEmpty(activeChat)}
                        >
                            <FontAwesomeIcon icon={faLocationArrow} className="font-size-lg"/>
                        </DropdownItem>
                        <DropdownItem divider/>
                        <DropdownItem className="d-flex align-items-center justify-content-center px-3" title="Контакт"
                                      onClick={() => setContactsModalOpen(true)}
                                      disabled={isEmpty(activeChat)}
                        >
                            <FontAwesomeIcon icon={faUser} className="font-size-lg"/>
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>

                <TextareaAutosize
                    className='form-control'
                    maxRows={5}
                    style={{resize: 'none'}}
                    placeholder={t('messages.new_message.placeholder_text', "Message...")}
                    required
                    disabled={isEmpty(activeChat)}
                    onChange={(event) => setMessageTextareaValue(event.target.value)}
                    value={messageTextareaValue}
                    onKeyPress={onMessageTextareaKeyPress}
                />
                <InputGroupAddon addonType="append" className={`append-group ${record ? 'is-recording' : ''}`}>

                    <Button disabled={isEmpty(activeChat)}
                            className={`btn-primary ${messageTextareaValue ? 'message-button' : 'record-button'} ${record ? 'is-recording' : ''}`}
                            onTouchStart={() => messageTextareaValue ? sendTextMessage() : setRecord(true)}
                            onTouchEnd={() => messageTextareaValue ? sendTextMessage() : setRecord(false)}
                            onMouseDown={() => messageTextareaValue ? sendTextMessage() : setRecord(true)}
                            onMouseUp={() => messageTextareaValue ? sendTextMessage() : setRecord(false)}
                            onMouseLeave={() => messageTextareaValue ? '' : setRecord(false)}
                            type="button"
                            color="primary">
                        {!messageTextareaValue && <i className="pe-7s-micro"></i>}
                        {messageTextareaValue && <i className="pe-7s-paper-plane"></i>}
                    </Button>
                </InputGroupAddon>
            </InputGroup>
        </Form>

        <Modal
            isOpen={fileModalOpen}
            toggle={toggleFileModal}
            className='chats-image-upload-modal'
        >
            <ModalHeader toggle={toggleFileModal} className='d-flex align-items-center'
                         style={{minHeight: 200}}>
                {/*можно будет использовать когда в ватсапе можно будет посылать файлы как нибудт иначе нежели чем просто видео*/}
                {/*{isVideo && <div*/}
                {/*    className="switch has-switch"*/}
                {/*    data-on-label="VIDEO"*/}
                {/*    data-off-label="FILE"*/}
                {/*    onClick={(e) => {*/}
                {/*        e.stopPropagation();*/}
                {/*        changeFileType(!uploadAsVideo);*/}
                {/*    }}*/}
                {/*>*/}
                {/*    <div className={cx("switch-animate", {*/}
                {/*        'switch-on': uploadAsVideo,*/}
                {/*        'switch-off': !uploadAsVideo,*/}
                {/*        'disabled': isEmpty(activeChat) || fileIsUploading || fileUploadFailed*/}

                {/*    })}>*/}
                {/*        <input type="checkbox"/>*/}
                {/*        <span className='switch-left bg-success'>VIDEO</span>*/}
                {/*        <label>&nbsp;</label>*/}
                {/*        <span className="switch-right bg-success">FILE</span>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*}*/}
                {fileIsUploading && <Loader type="line-scale-party"/>}
                {!fileIsUploading && <>
                    {fileUploadFailed && <img src={fileUploadFailed} style={{maxHeight: 165}}/>}
                    {!fileUploadFailed && <>
                        {isImage && <img src={fileUploaded} className='mb-2 img-fluid'
                                         style={{maxWidth: 420, maxHeight: 300}}/>}
                        {isAudio && <div className="audio-file-type">
                            <audio src={fileUploaded} controls></audio>
                        </div>}
                        {isVideo && <div className="video-file-type">
                            <video controls>
                                <source src={fileUploaded}/>
                                <a href={fileUploaded} target='_blank' rel="noopener noreferrer"
                                   className='message-file'>
                                                    <span
                                                        className="font-size-xlg pe-7s-video m-1 mr-2 text-decoration-none text-dark"/>
                                    <span>{fileUploaded}</span>
                                </a>
                            </video>
                        </div>}
                        {(!isAudio && !isVideo && !isImage) && <i className='pe-7s-file' style={{fontSize: '5rem'}}/>}
                    </>
                    }
                </>
                }


            </ModalHeader>

            <ModalBody className='p-0'>
                <Form className="text-center" onSubmit={onImageTextareaSubmit}>
                    <InputGroup className='px-2 py-3 py-md-2'>
                        <Input
                            type="textarea"
                            style={{resize: 'none'}}
                            placeholder={t('messages.new_message.placeholder_text', "Message...")}
                            onChange={(event) => setMessageTextareaValue(event.target.value)}
                            value={messageTextareaValue}
                            disabled={isEmpty(activeChat) || fileIsUploading || fileUploadFailed || isAudio}
                            onKeyPress={onImageTextareaKeyPress}
                        />
                        <InputGroupAddon addonType="append">
                            <Button color="primary"
                                    disabled={isEmpty(activeChat) || fileIsUploading || fileUploadFailed}>
                                {t('messages.new_message.button_send_msg', "Send")}
                                <br/>
                                <span className="opacity-7">
                                    (Enter)
                                </span>
                            </Button>

                        </InputGroupAddon>
                    </InputGroup>
                </Form>
            </ModalBody>
        </Modal>

        <Modal
            isOpen={locationModalOpen}
            toggle={() => {
                setLocationModalOpen(!locationModalOpen);
                setLocationLatLng(null);
            }}>
            <ModalHeader className="d-block">
                <GoogleMapWrapper
                    height="350px"
                    modes={true}
                    callback={setLocationLatLng}
                />
            </ModalHeader>
            <ModalBody className='p-0'>
                <Form className="text-center" onSubmit={sendLocationMessage}>
                    <InputGroup className='px-2 py-3 py-md-2'>
                        <Input
                            type="textarea"
                            style={{resize: 'none'}}
                            placeholder={t('messages.new_message.placeholder_text', "Message...")}
                            onChange={(event) => setMessageTextareaValue(event.target.value)}
                            value={messageTextareaValue}
                            disabled={isEmpty(activeChat)}
                            onKeyDown={(e) => e.keyCode === 13 && sendLocationMessage(e)}
                        />
                        <InputGroupAddon addonType="append">
                            <Button color="primary" disabled={isEmpty(activeChat) || isEmpty(locationLatLng)}>
                                {t('messages.new_message.button_send_msg', "Send")}
                                <br/>
                                <span className="opacity-7">
                                    (Enter)
                                </span>
                            </Button>
                        </InputGroupAddon>
                    </InputGroup>
                </Form>
            </ModalBody>
        </Modal>

        <Modal
            isOpen={contactsModalOpen}
            toggle={() => {
                setContactsModalOpen(!contactsModalOpen);
                setContactsList([]);
            }}
        >
            <ModalHeader toggle={() => {
                setContactsModalOpen(!contactsModalOpen);
                setContactsList([]);
            }}>
                {t('pages.contacts.title', "Send contact")}
            </ModalHeader>
            <ModalBody className="pb-0">
                <ListContacts state={contactsList} setState={setContactsList}/>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-center">
                <Form onSubmit={sendContactMessage}>
                    <ButtonWithSpinner
                        title={t('messages.new_message.button_send_msg', "Send")}
                        type="submit"
                        loading={contactsLoading}
                        disabled={!contactsList?.length}
                    />
                </Form>
            </ModalFooter>
        </Modal>
    </>;
}


const mapStateToProps = state => ({
    activeChat: state.Chats.activeChat,
    wsConnected: state.Chats.wsConnected,
});

const mapDispatchToProps = dispatch => ({
    sendMessage: (chat_id, contentType, payload, callback) => dispatch(sendMessage(chat_id, contentType, payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SendForm);
